import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { TrustStrip } from './components/TrustStrip';
import { PainPointsSection } from './components/PainPointsSection';
import { ConditionsSection } from './components/ConditionsSection';
import { AspenDifferenceSection } from './components/AspenDifferenceSection';
import { VideoSection } from './components/VideoSection';
import { FirstVisitSteps } from './components/FirstVisitSteps';
import { TreatmentFrequency } from './components/TreatmentFrequency';
import { ReviewsSection } from './components/ReviewsSection';
import { FitSection } from './components/FitSection';
import { FAQSection } from './components/FAQSection';
import { SafetySection } from './components/SafetySection';
import { SEOResourcesSection } from './components/SEOResourcesSection';
import { FinalCTA } from './components/FinalCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  useEffect(() => {
    document.title = 'Laser Therapy Bloomfield Hills | Aspen Class IV Laser | Paragon Chiropractic';
  }, []);
  return <main className="w-full min-h-screen bg-white overflow-x-hidden pb-20 lg:pb-0" data-id="element-0">
      <HeroSection data-id="element-1" />
      <TrustStrip data-id="element-2" />
      <PainPointsSection data-id="element-3" />
      <ConditionsSection data-id="element-4" />
      <AspenDifferenceSection data-id="element-5" />
      <VideoSection data-id="element-6" />
      <FirstVisitSteps data-id="element-7" />
      <TreatmentFrequency data-id="element-8" />
      <ReviewsSection data-id="element-9" />
      <FitSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <SafetySection data-id="element-12" />
      <SEOResourcesSection data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <StickyMobileCTA data-id="element-15" />
    </main>;
}